import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getKitRefillLogsDateWiseAPI } from '../../apis/hyperwolf/kitRefillLogs'

export const kitRefillLogsDateWise = createAsyncThunk(
  'kitRefillLogs/kitRefillLogsDateWise',
  async (data, { rejectWithValue }) => {
    try {
      const res = await getKitRefillLogsDateWiseAPI(data)
      return res
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

const kitRefillLogsSlice = createSlice({
  name: 'kitRefillLogs',
  initialState: {
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(kitRefillLogsDateWise.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(kitRefillLogsDateWise.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(kitRefillLogsDateWise.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  }
})

export default kitRefillLogsSlice.reducer;
